import { createSelector } from 'reselect'
import i18n from '../../../i18n'
import { IProvenance } from '../../../models/Provenance'
import { IStore } from '../../index'

export function getProvenances(state: IStore) {
  return state.provenances.provenances
}

export function getInitialProvenances(): IProvenance[] {
  return [
    {
      id: 0,
      idUser: 0,
      isDeleted: false,
      name: i18n.t('reservation_phone'),
    },
    {
      id: 0,
      idUser: 0,
      isDeleted: false,
      name: i18n.t('email'),
    },
    {
      id: 0,
      idUser: 0,
      isDeleted: false,
      name: 'iCalendar',
    },
    {
      id: 0,
      idUser: 0,
      isDeleted: false,
      name: 'booking.com',
    },
  ]
}

export function getProvenanceWithoutDeleted(state: IStore) {
  return state.provenances.provenances.filter(
    provenance => !provenance.isDeleted,
  )
}

export const getProvenancesWithInitial = createSelector(
  [getProvenanceWithoutDeleted, getInitialProvenances],
  (provenances, initialProvenances) => {
    const initialProvenancesNames = initialProvenances.map(p => p.name)

    return initialProvenances.concat(
      provenances.filter(p => !initialProvenancesNames.includes(p.name)),
    )
  },
)
